// exp_PORTFOLIO-58018_file
import { FC } from 'react';

import {
    Avatar,
    Card,
    Cell,
    CellText,
    Stepper,
    StepperContent,
    StepperMarker,
    StepperStep,
    Text,
    VSpacing,
} from '@hh.ru/magritte-ui';

import useTrls from 'hooks/translation/useTrls';

const TrlKeys = {
    title: 'VrCampaignBuilderPage.sidebar.title',
    stepper: {
        1: {
            label: 'VrCampaignBuilderPage.sidebar.1',
            description: '',
        },
        2: {
            label: 'VrCampaignBuilderPage.sidebar.2',
            description: '',
        },
        3: {
            label: 'VrCampaignBuilderPage.sidebar.3',
            description: 'VrCampaignBuilderPage.sidebar.3.description',
        },
    },
};

export const Sidebar: FC = () => {
    const trls = useTrls();

    return (
        <Card padding={24} stretched borderRadius={24} borderWidth="default">
            <Text typography="subtitle-1-semibold">{trls(TrlKeys.title)}</Text>
            <VSpacing default={20} />
            <Stepper orientation="vertical">
                {Object.entries(TrlKeys.stepper).map(([key, value]) => (
                    <StepperStep key={key}>
                        <StepperMarker>
                            <Avatar
                                size={24}
                                shapeCircle
                                aria-label={`step-${key}`}
                                letters={key}
                                mode="letters"
                                style="color-1"
                            />
                        </StepperMarker>
                        <StepperContent>
                            <Cell>
                                <CellText>{trls(value.label)}</CellText>
                                {value.description && (
                                    <CellText style="secondary" typography="label-3-regular">
                                        {trls(value.description)}
                                    </CellText>
                                )}
                            </Cell>
                        </StepperContent>
                    </StepperStep>
                ))}
            </Stepper>
        </Card>
    );
};
